module.exports = __webpack_public_path__ + "img/Icon-Procedures.6a1cac0b.svg";